import React, { useEffect, useState, useRef } from "react";
import { AddCircleOutline, Delete, Edit } from "@mui/icons-material";
import { Button, IconButton, Tooltip } from "@mui/material";
import { Row, Col } from "react-bootstrap";
import { useDispatch, useSelector } from "react-redux";
import CompanyVeiwController from "../../redux/actions/companyApiActions";
import CompanyFormModal from "./AddCompany";
import "../../styles/styles.css";
import "../../styles/layout.css";
import ReusableGrid from "../../components/ag grid/ReusableGrid";
import CompanyViewModal from "./CompanyViewModal";
import VisibilityIcon from "@mui/icons-material/Visibility";
import ExportButton from "../../components/ag grid/ExportButton";
import PageSizeSelector from "../../components/ag grid/PageSizeSelector";
import { IMAGE_URL } from "../../services/api";
import ProtectedImage from "../../components/ProtectedImage";
const CompanyList = () => {
  const dispatch = useDispatch();
  const gridRef = useRef(null);

  const [showModal, setShowModal] = useState(false);
  const [editCompany, setEditCompany] = useState(null);
  const [selectedRows, setSelectedRows] = useState([]);
  const [viewModalOpen, setViewModalOpen] = useState(false);
  const [selectedCompany, setSelectedCompany] = useState(null);
  const [pageSize, setPageSize] = useState(10);

  const { getCompanies, deleteCompany } = CompanyVeiwController();
  const { companies } = useSelector((state) => state.company);

  useEffect(() => {
    dispatch(getCompanies());
  }, []);

  const handleDelete = (id) => dispatch(deleteCompany(id));
  const handleEdit = (company) => {
    setEditCompany(company);
    setShowModal(true);
  };
  const handleView = (company) => {
    setSelectedCompany(company);
    setViewModalOpen(true);
  };
  const columnDefs = [
    {
      headerCheckboxSelection: true,
      checkboxSelection: true,
      maxWidth: 50,
      pinned: "left"
    },
    {
      headerName: "SR.No",
      valueGetter: (params) => params.node.rowIndex + 1,
      maxWidth: 80
    },
    {
      headerName: "Company Name",
      field: "company_name",
      flex: 1,
      cellRenderer: (params) => {
        const maxLength = 15; // Limit to 50 characters
        const value = params.value || "";
        const truncated =
          value.length > maxLength
            ? value.substring(0, maxLength) + "..."
            : value;
        return truncated;
      }
    },
    {
      headerName: "Logo",
      field: "company_logo",
      maxWidth: 120,
      cellRenderer: (params) =>
        params.value ? (
          <>
            <ProtectedImage
              path={params.value}
              alt="Company Logo"
              className="company-logo"
            />
            {/* <img
              src={`${IMAGE_URL}${params.value}`}
              alt="Company Logo"
              style={{
                width: "100%", // or set a fixed width like 200px
                height: "100%", // or fixed height
                objectFit: "contain"
              }}
            /> */}
          </>
        ) : (
          "N/A"
        )
    },
    {
      headerName: "Description",
      field: "description",
      flex: 1,
      cellRenderer: (params) => {
        const maxLength = 15; // Limit to 50 characters
        const value = params.value || "";
        const truncated =
          value.length > maxLength
            ? value.substring(0, maxLength) + "..."
            : value;
        return truncated;
      }
    },
    {
      headerName: "Location",
      field: "location",
      flex: 1
    },
    {
      headerName: "Emp Strength",
      field: "employee_strength",
      flex: 0.5
    },
    {
      headerName: "Actions",
      field: "actions",
      pinned: "right",
      minWidth: 120,
      maxWidth: 150,
      suppressSizeToFit: true,
      cellRenderer: (params) => (
        <div style={{ display: "flex", justifyContent: "center", gap: 8 }}>
          <Tooltip title="View">
            <IconButton
              color="primary"
              size="small"
              onClick={() => handleView(params.data)}
            >
              <VisibilityIcon />
            </IconButton>
          </Tooltip>
          <Tooltip title="Edit">
            <IconButton size="small" onClick={() => handleEdit(params.data)}>
              <Edit fontSize="small" />
            </IconButton>
          </Tooltip>
          <Tooltip title="Delete">
            <IconButton
              size="small"
              sx={{ color: "#d32f2f" }}
              onClick={() => handleDelete(params.data.id)}
            >
              <Delete fontSize="small" />
            </IconButton>
          </Tooltip>
        </div>
      )
    }
  ];

  return (
    <div>
      <div
        className="d-flex flex-wrap mb-3 gap-2"
        style={{ justifyContent: "space-between" }}
      >
        <div className="mt-2">
          <Button
            variant="contained"
            startIcon={<AddCircleOutline />}
            onClick={() => {
              setEditCompany(null);
              setShowModal(true);
            }}
            sx={{
              borderRadius: "8px",
              backgroundColor: "#1976d2",
              textTransform: "none",
              paddingX: 2,
              height: "40px",
              fontSize: "0.875rem"
            }}
          >
            Add Company
          </Button>
        </div>
        <div style={{ display: "flex", alignItems: "center", gap: "12px" }}>
          <div>
            <ExportButton
              gridRef={gridRef}
              fileName="EmployeeList.xlsx"
              exportColumns={[
                "company_name",
                "description",
                "location",
                "employee_strength",
                "email"
              ]}
              disabled={selectedRows.length === 0}
              size="medium"
            />
          </div>
          <PageSizeSelector
            pageSize={pageSize}
            onChange={(e) => setPageSize(Number(e.target.value))}
          />
        </div>
      </div>

      {/* <div className="label-card">
        <Row className="justify-content-between w-100">
          <Col>
            <h3>Company List</h3>
          </Col>
        </Row>
      </div> */}

      <div className="ag-theme-material" style={{ height: "70vh" }}>
        <ReusableGrid
          rowData={companies}
          columnDefs={columnDefs}
          gridRef={gridRef}
          pagination={true}
          pageSize={pageSize}
          onSelectionChanged={(rows) => setSelectedRows(rows)}
        />
      </div>

      <CompanyFormModal
        show={showModal}
        handleClose={() => setShowModal(false)}
        initialData={editCompany}
      />
      <CompanyViewModal
        show={viewModalOpen}
        handleClose={() => setViewModalOpen(false)}
        company={selectedCompany}
      />
    </div>
  );
};

export default CompanyList;
